import axios from 'axios'
import endpoint from '../endpoint'

const common = {
  checkServer: () => {
    const url = `${endpoint.checkServer}`
    return axios.get(url)
  }
}

export default common
